<template>
  <div class="index">
    <div class="top"
      style="width:100%;height:600px;background:url('static/top_bg2.png') no-repeat;background-size:auto 100%;background-position:0px 0px">
    </div>

    <topNav></topNav>


    <!--<img src="static/china_real_estate_industry_green_supply_chain_action.png" style="position:absolute;left:25px;top:150px;width:50%;" />-->
    <div style="position:absolute;left:20px;top:150px;width:68%;text-align:left;" class="brief_1 Impact">Green Supply
      Chain Action in China’s Real Estate Industry</div>

    <!--<img src="static/under_top_logo.png" style="position:absolute;left:25px;top:200px;width:150px;" />-->

    <div v-if="$store.state.language === 'cn'" style="position:absolute;left:20px;top:260px;width:55%;text-align:left;" class="brief_1 Impact">
      中国房地产行业<br />绿色供应链行动</div>



    <div class="aboutUs" style="width:100%;height:800px;margin:50px auto 0px auto;background:url('static/index_about_us_num_bg.png');
    background-size:65% auto;background-position:right bottom;background-repeat:no-repeat">

      <!--<div style="width:80%;margin:0 auto"><img src='static/about_us.png' style="width:180px;display:block;"></div>-->
      <div style="width:80%;margin:0 auto;color:#57802b;text-align:left;" class="brief_1 Impact">About GSC Action</div>
      <div style="width:80%;margin:0 auto" v-if="$store.state.language === 'cn'"><img src='static/about_us_text.png'
          style="width:180px;display:block;margin-top:10px"></div>

      <div style="width:80%;margin:0 auto">

        <p style="text-align:left;" v-if="$store.state.language === 'cn'">
          <!-- 绿链行动以房地产企业及其上游供应商为主体、施行绿色采购。由第三方独立机构提供技术支持，推选环境表现良好的供应商进入推荐采购名单。房地产企业将根据制定的一系列绿色采购方案进行采购。目前房地产行业绿色供应链行动已有100多家房地产企业加入，共推出19个品类“白名单”评审规则，通过环境合规白名单查询平台收录超100万家白名单企业，17个品类“绿名单”导则，“绿名单”供应商企业58家。 -->
          中国房地产行业绿色供应链行动（简称“绿链行动”）以房地产企业及其上游供应商为主体、施行绿色采购。由第三方独立机构提供技术支持，推选环境表现良好的供应商进入推荐采购名单，房地产企业将根据制定的一系列绿色采购方案进行采购。
        </p>
        <p style="text-align:left;" v-else>
          <!-- Green supply chain action (GSC action) mainly focuses on real estate enterprises and their upstream suppliers and implements green procurement. Independent third-party agencies provide technical support and select suppliers with good environmental performance to enter the recommended procurement list. Real estate enterprises will purchase according to a series of green procurement plans. At present, GSC action has attracted more than 100 real estate enterprises to join in, and has launched a total of 19 "white list" category guidelines. Also, GSC action has included more than 1 million white list enterprises through the environmental compliance whitelist query platform, launched 19 "green list" category guidelines, and attracted over 80 "green list" enterprises. -->
          Green supply chain action (GSC action) mainly focuses on real estate enterprises and their upstream suppliers and implements green procurement. Independent third-party agencies provide technical support and select suppliers with good environmental performance to enter the recommended procurement list. Real estate enterprises will purchase according to a series of green procurement plans. At present, GSC action has attracted more than 90 real estate enterprises to join in, and has launched a total of 26 "white list" category guidelines. Also, GSC action has included more than 1 million white list enterprises through the environmental compliance whitelist query platform, launched 26 "green list" category guidelines, and attracted over 70 "green list" enterprises.
        </p>

      </div>

      <!-- <div style="">
        <img src="static/index_num.jpg" style="width:80%" />
      </div> -->
      <div class="flex_1">
      <div class="pos_rit pointer" @click="addck(1)">
        <!-- <div class="font_style_fx shadow">100<span v-if="$store.state.language !== 'cn'">+</span></div> -->
        <!-- <div class="font_style_fx shadow">90<span v-if="$store.state.language !== 'cn'">+</span></div> -->
        <div class="font_style_fx shadow">101<span v-if="$store.state.language !== 'cn'">+</span></div>
        <!-- <div class="font_pos green"  v-if="$store.state.language === 'cn'">多家</div> -->
        <div class="font_pos green"  v-if="$store.state.language === 'cn'">家</div>
        <div class="font_pos green" v-else></div>
        <div class="font_pos_1 shadow2"  v-if="$store.state.language === 'cn'">房地产企业</div>
        <div class="font_pos_1 break shadow2" v-else>real estate enterprises</div>
      </div>
      <div class="pos_rit pointer" @click="addck(2)">
        <!-- <div class="font_style_fx shadow">19</div> -->
        <div class="font_style_fx shadow">26</div>
        <div class="font_pos font_pospl green" v-if="$store.state.language === 'cn'">个</div>
        <div class="font_pos_1 break shadow2"  v-if="$store.state.language === 'cn'">绿名单品类</div>
        <div class="font_pos_1 break shadow2" v-else>green list categories</div>
      </div>
      <div class="pos_rit pointer" @click="addck(3)">
        <!-- <div class="font_style_fx bai shadow">19</div> -->
        <div class="font_style_fx bai shadow">26</div>
        <div class="font_pos font_pospl green" v-if="$store.state.language === 'cn'">个</div>
        <div class="font_pos_1 break shadow2" v-if="$store.state.language === 'cn'">白名单品类</div>
        <div class="font_pos_1 break shadow2" v-else>white list categories</div>
      </div>
      <div class="pos_rit pointer" @click="addck(4)">
        <!-- <div class="font_style_fx bai shadow">80+</div> -->
        <!-- <div class="font_style_fx bai shadow">70</div> -->
        <div class="font_style_fx bai shadow">100</div>
        <!-- <div class="font_pos bai green" v-if="$store.state.language === 'cn'">多家</div> -->
        <div class="font_pos bai green" v-if="$store.state.language === 'cn'">+家</div>
         <div class="font_pos bai green" v-else>+</div>
        <div class="font_pos_1 shadow2" v-if="$store.state.language === 'cn'">绿名单企业</div>
        <div class="font_pos_1 break shadow2" v-else>green list enterprises</div>
      </div>
      <div class="pos_rit pointer" @click="addck(5)">
        <div class="font_style_fx bai shadow" v-if="$store.state.language === 'cn'">超100万</div>
        <div class="font_style_fx bai shadow" v-else>1 million+</div>
        <div class="font_pos bai green" v-if="$store.state.language === 'cn'">家</div>
        <div class="font_pos_1 shadow2" v-if="$store.state.language === 'cn'">白名单企业</div>
        <div class="font_pos_1 shadow2" v-else>white list enterprises</div>
      </div>
      <div class="pos_rit pointer" @click="addck()">
        
      </div>
    </div>

      <!--aboutUs end-->
    </div>



    <div
      style="position:relative;background:url(static/green_bg.png); background-repeat:no-repeat;background-size:auto 100%;width:100%;overflow:hidden;height:650px;">
      <!--发起组织名单 start-->

      <img src="static/left_line.png" style="height:240px;top:140px;position:absolute;left:25px;" />

      <!--<img src="static/organization_list.png" style="width:150px;top:60px;position:absolute;left:40px;" />-->

      <div style="width:80%;top:30px;position:absolute;left:40px;text-align:left;font-size:20px;" class="brief_1 Impact">
        GSC Action Real Estate Enterprises Member Directory</div>

      <!--<img src="static/fq_name_list.png" style="width:100px;top:90px;position:absolute;left:40px;" />-->


      <div v-if="$store.state.language === 'cn'" style="width:80%;top:90px;position:absolute;left:40px;;text-align:left;font-size:20px;" class="brief_1 Impact">
        绿色行动房企名单</div>



      <div class="swiper-container swiper_fqz"
        style="width:90%;position:absolute;left:40px;top:120px;height:235px;background:white">
        <!--轮播图-->
        <div class="swiper-wrapper">
          <!-- <div class="swiper-slide"> <img src="static/slide01.jpg" style="height:235px;" /></div> -->
          <div class="swiper-slide"> <img src="static/slide01.jpg" style="height:235px;width:100%" /></div>
          <!-- <div class="swiper-slide"> <img src="static/slide02.jpg"  style="height:235px;width:100%"  /></div>
                                                  <div class="swiper-slide"> <img src="static/slide03.jpg"  style="height:235px;width:100%"  /></div> -->
        </div>
        <!-- 如果需要分页器
                                            <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
                                                  <div class="swiper-button-next"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>

      <!--<img src="static/fq_zz_index.png" style="width:80px;top:430px;position:absolute;left:40px;" title="发起组织" />-->


      <div style="width:160px;top:430px;position:absolute;left:40px;font-size:20px;" class="brief_1 Impact" v-if="$store.state.language === 'cn'">绿色行动房企名单</div>
      <div style="width:160px;top:430px;position:absolute;left:40px;font-size:13px;" class="brief_1 Impact" v-else>GSC Action Real Estate Enterprises Member Directory</div>

      <img src="static/line01.png" style="width:160px;top:460px;position:absolute;left:40px;height:1px;" title="发起组织" />

      <div style="width:90%;top:480px;position:absolute;left:30px;color:#ffffff;height:90px;" id="title">
        <ul>
          <li id="slide_01_text" :class="[slide01show01 ? 'show' : 'hidden']"
            style="text-align:left;height:90px;position:relative;overflow:hidden;">
            <!-- <div style="width:100%;top:0px;position:absolute;left:0px;" v-if="$store.state.language === 'cn'">截至目前加入绿链行动房企共100多家</div>
            <div style="width:100%;top:0px;position:absolute;left:0px;" v-else>More than 100 real estate enterprises have joined the GSC action since its launch
More information</div> -->
            <div style="width:100%;top:0px;position:absolute;left:0px;" v-if="$store.state.language === 'cn'">截止至2025年12月31日</div>
            <div style="width:100%;top:0px;position:absolute;left:0px;" v-else>More than 90 real estate enterprises have joined the GSC action since its launch
More information</div>
            <!-- <img src="static/look_detail.png" style="width:60px;top:60px;position:absolute;left:0px;" title="查看详情" /> -->
            <div v-if="$store.state.language === 'cn'" style="width:60px;top:57px;position:absolute;left:0px;color: white;font-size: 14px;" >查看详情</div>
            <div v-else style="width:60px;top:57px;position:absolute;left:0px;color: white;font-size: 14px;" >More information</div>
            <img src="static/to_arrow.png" style="width:15px;top:58px;position:absolute;left:80px;" title="查看详情" />
          </li>

        </ul>

      </div>

      <!-- <div style="background:#ffffff;bottom:0px;position:absolute;width:100%;height:40px;">
      <img src="static/1·2·3-1.png"  :class="[slide01show01 ? 'show' : 'hidden']"  style="width:80%;margin:10px auto 0px auto;" title="当前显示图片" />
      <img src="static/1·2·3-2.png"  :class="[slide01show02 ? 'show' : 'hidden']" style="width:80%;margin:10px auto 0px auto;" title="当前显示图片" />
      <img src="static/1·2·3-3.png"  :class="[slide01show03 ? 'show' : 'hidden']"  style="width:80%;margin:10px auto 0px auto;" title="当前显示图片" />

      </div> -->
      <!--发起组织名单 end-->
    </div>



    <div style="position:relative;background:#f6f6f6;width:100%;overflow:hidden;height:1450px;">
      <!--最新动态 start-->
      <router-link to="news">
        <img src="static/latest_news.png" style="width:150px;top:60px;position:absolute;left:40px;" />

        <img v-if="$store.state.language === 'cn'" src="static/latest_news_text.png" style="width:100px;top:100px;position:absolute;left:40px;" />


        <div
          style="background:url(static/more_news_bg2.png) 100% no-repeat;width:120px;top:100px;position:absolute;right:40px;height:30px;">

          <!-- <img src="static/more_news_text.png" style="width:50px;margin-top:10px;position:absolute;left:20px;" /> -->
          <div  v-if="$store.state.language === 'cn'" style="width:52px;margin-top:6px;position:absolute;left:20px;color: white;font-size: 13px;" >更多新闻</div>
          <div v-else style="width:66px;margin-top:8px;position:absolute;left:13px;color: white;font-size: 13px;" >More News</div>

          <img src="static/to_right_arrow.png" style="width:30px;margin-top:10px;position:absolute;right:10px;" />

        </div>
      </router-link>

      <div style="position:absolute;top:150px;width:100%;height:300px;overflow:hidden;">
        <div style="position:absolute;top:30px;width:100%;">中国房地产市场绿色供应链行动</div>

        <video src="http://gsc.see.org.cn/uploadfile/about_lvlian_video.m4v"
          style="position:absolute;top:50px;width:80%;height:250px;left:10%;" controls></video>

      </div>


      <div style="position:absolute;top:400px;width:100%;height:300px;overflow:hidden;">
        <div style="position:absolute;top:70px;width:100%;">建房子会破坏环境吗？</div>

        <video src="http://gsc.see.org.cn/uploadfile/five_year_video.mp4"
          style="position:absolute;top:70px;width:80%;height:250px;left:10%;" controls></video>

      </div>



      <div class="swiper-container swiper_news"
        style="width:80%;position:absolute;left:10%;top:720px;height:300px;background:white;overflow:hidden;">
        <!--轮播图-->
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="static/slide01.jpg" style="height:235px;" />
            <div style="text-align:left;padding:0 10px;">“绿名单”申报开启, 欢迎报名成为房地产绿链行动</div>
          </div>
          <div class="swiper-slide"> <img src="static/slide01.jpg" style="height:235px;" />
            <div style="text-align:left;padding:0 10px;">房地产绿链行动五周年再树里程碑，多项成果首发</div>
          </div>
          <div class="swiper-slide"> <img src="static/slide01.jpg" style="height:235px;" />
            <div style="text-align:left;padding:0 10px;">绿色供应链“99公益日”筹款成绩单——感谢有您</div>
          </div>
        </div>
        <!-- 如果需要分页器
                                            <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
                                                  <div class="swiper-button-next"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>

      <div
        style="width:80%;position:absolute;left:10%;top:1020px;height:400px;overflow:hidden;background:url(static/green_bg_small.png) repeat">

        <div style="color:#ffffff;position:absolute;top:40px;left:20px;">新闻中心</div>
        <div style="color:#ffffff;position:absolute;top:45px;right:20px;">2021-06-07</div>

        <div style="color:#ffffff;position:absolute;top:90px;left:20px;">
          <p style="text-align:left;font-weight:bolder">“绿名单” 申报开启<br />
            欢迎报名成为房地产绿链行动
          </p>
          <p style="text-align:left;">
            当前， “绿名单” 项目的评价标准已完成， “绿名单” 申报入口已在绿链官网上线，欢迎各企业踊跃申报！依据“绿名单”标准，在资源、能源、环境等几方面表现优秀的供应链企业将通过筛选后进入
            “绿名单”，这些供应商将会得到房地产企业的优先采购。
          </p>

          <p style="text-align:left;margin-top:30px;"><span
              style="display:block;margin-top:3px;float:left;margin-right:10px;"  v-if="$store.state.language === 'cn'">了解更多</span>
              <span
              style="display:block;margin-top:3px;float:left;margin-right:10px;" v-else>More</span>
               <img
              src="static/to_arrow.png" /></p>


        </div>


      </div>





      <!--最新动态 end-->
    </div>





    <div
      style="position:relative;background:url(static/green_purchase_guid_bg.png);width:100%;overflow:hidden;height:660px;">
      <!--绿色采购指南 start-->

      <img src="static/green_procurement_guide.png" style="width:180px;top:60px;position:absolute;left:40px;" />


      <img v-if="$store.state.language === 'cn'" src="static/green_purchase_guid_text.png" style="width:140px;top:120px;position:absolute;left:40px;" />

      <div style="width:30%;top:160px;position:absolute;left:0px;color:#ffffff;font-size:12px;">
        <ul style="margin:0px;padding:0px;">
          <li :class="[lscgzn ? 'itemActive item' : 'itemNoActive item']" @click="getlscgzn()">
            <img src="static/green_purchase_guid_text.png" style="width:90px;margin-top:10px;" />
            <img src="static/green_guid_english.png" style="width:90px;" />
          </li>
          <li :class="[bmdpsgz ? 'itemActive item' : 'itemNoActive item']" @click="getbmdpsgz()">

            <img src="static/bmdpsgz_text.png" style="width:90px;margin-top:10px;" />
            <img src="static/bmdpsgz_en_text.png" style="width:150px;margin-left:15px;" />

          </li>
          <li :class="[lmdpsgz ? 'itemActive item' : 'itemNoActive item']" @click="getlmdpsgz()">
            <img src="static/lmdpsgz_ch_text.png" style="width:90px;margin-top:10px;" />

            <img src="static/lmdpsgz_en_text.png" style="width:150px;margin-left:15px;" />


          </li>
          <li :class="[hmdpsgz ? 'itemActive item' : 'itemNoActive item']" @click="gethmdpsgz()">
            <img src="static/hmdpsgz_ch_text.png" style="width:90px;margin-top:10px;" />
            <img src="static/hmdpsgz_en_text.png" style="width:150px;margin-left:15px;" />
          </li>

        </ul>

      </div>

      <div :class="[lscgzn ? 'lscgzn_content_box show' : 'lscgzn_content_box hidden']">
        <!--绿色采购指南内容-->
        <div style="">
          <img src="static/lscgzn_content_title.png" style="width:180px;top:15px;left:10px;position:absolute;" />
          <img src="static/green_procurement_guide_for_china_r_eal_estate_industry.png"
            style="width:180px;top:40px;left:10px;position:absolute;" />
          <img src="static/line_dot.png" style="width:180px;top:70px;left:10px;position:absolute;" />
        </div>
        <div class="lscgzn_content_html" v-html="lscgznNew.content"
          style="padding-left:2%;padding-right:2%;max-height:500px;overflow-y:scroll;width:90%;position:absolute;top:15%;height:85%">
        </div>
      </div>


      <div :class="[bmdpsgz ? 'bmdpsgz_content_box show' : 'bmdpsgz_content_box hidden']">
        <!--白名单评审规则list-->
        <div style="">
          <img src="static/bmdpsgz_list_title2.png" style="width:180px;top:15px;left:10px;position:absolute;" />
          <img src="static/bmdpsgz_en_list_title.png" style="width:240px;top:40px;left:10px;position:absolute;" />
          <img src="static/line_dot.png" style="width:180px;top:70px;left:10px;position:absolute;" />
        </div>
        <div class="bmdpsgz_list_box">
          <ul class="mdpsgz_item" v-for="(bmdpsgzItem, bmdpsgzIndex) in bmdpsgzList" :key="bmdpsgzIndex">
            <li style="float:left;margin-top:0px;width:15%;padding:0px;margin-left:1%;margin-right:1%;">
              <div
                style="text-align:center;font-weight:700;font-size:12px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">
                {{ bmdpsgzItem.createdat.substring(5, 10) }}</div>
              <div style="text-align:center;">{{ bmdpsgzItem.createdat.substring(0, 4) }}</div>
            </li>
            <li style="text-align:left;width:65%;float:left;padding:0px;margin-right:1%;">{{ bmdpsgzItem.articleName }}</li>
            <li @click="showOrHideDetail(bmdpsgzItem.articleId, $event)"
              style="float:left;margin-top:0px;margin-left:1%;margin-right:1%;border:1px solid #8fa926;border-radius:7px;color:#8fa926;width:15px;height:15px;line-height:15px;font-size:15px;">
              +</li>
            <div style="width:100%;height:2px;clear:both;"></div>
            <!-- <li class="detailContent" :id="bmdpsgzItem.articleId" style="width:100%;display:none;text-align:left;" v-html="bmdpsgzItem.content.replaceAll('/uploadfile','http://gsc.see.org.cn/uploadfile')"></li> -->
            <li class="detailContent" :id="bmdpsgzItem.articleId" style="width:100%;display:none;text-align:left;"
              v-html="bmdpsgzItem.content"></li>

          </ul>
        </div>
      </div>


      <div :class="[lmdpsgz ? 'lmdpsgz_content_box show' : 'lmdpsgz_content_box hidden']">
        <!--绿名单评审规则list-->
        <div style="">
          <img src="static/lmdpsgz_list_title2.png" style="width:180px;top:15px;left:10px;position:absolute;" />
          <img src="static/lmdpsgz_en_list_title.png" style="width:240px;top:40px;left:10px;position:absolute;" />
          <img src="static/line_dot.png" style="width:180px;top:70px;left:10px;position:absolute;" />
        </div>
        <div class="bmdpsgz_list_box">
          <ul class="mdpsgz_item" v-for="(lmdpsgzItem, lmdpsgzIndex) in lmdpsgzList" :key="lmdpsgzIndex">
            <li style="float:left;margin-top:0px;width:15%;padding:0px;margin-left:1%;margin-right:1%;">
              <div
                style="text-align:center;font-weight:700;font-size:12px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">
                {{ lmdpsgzItem.createdat.substring(5, 10) }}</div>
              <div style="text-align:center;">{{ lmdpsgzItem.createdat.substring(0, 4) }}</div>
            </li>
            <li style="text-align:left;width:65%;float:left;padding:0px;margin-right:1%;">{{ lmdpsgzItem.articleName }}</li>
            <li @click="showOrHideDetail(lmdpsgzItem.articleId, $event)"
              style="float:left;margin-top:0px;margin-left:1%;margin-right:1%;border:1px solid #8fa926;border-radius:7px;color:#8fa926;width:15px;height:15px;line-height:15px;font-size:15px;">
              +</li>
            <div style="width:100%;height:2px;clear:both;"></div>
            <!-- <li class="detailContent" :id="lmdpsgzItem.articleCode" style="width:100%;display:none;text-align:left;" v-html="lmdpsgzItem.content.replaceAll('/uploadfile','http://www.cura.cn/uploadfile')"></li> -->
            <li class="detailContent" :id="lmdpsgzItem.articleId" style="width:100%;display:none;text-align:left;"
              v-html="lmdpsgzItem.content"></li>

          </ul>
        </div>
      </div>

      <div :class="[hmdpsgz ? 'hmdpsgz_content_box show' : 'hmdpsgz_content_box hidden']">
        <!--黑名单评审规则list-->
        <div style="">
          <img src="static/hmdpsgz_list_title2.png" style="width:180px;top:15px;left:10px;position:absolute;" />
          <img src="static/hmdpsgz_en_list_title.png" style="width:180px;top:40px;left:10px;position:absolute;" />
          <img src="static/line_dot.png" style="width:180px;top:70px;left:10px;position:absolute;" />
        </div>
        <div class="bmdpsgz_list_box">
          <ul class="mdpsgz_item" v-for="(hmdpsgzItem, hmdpsgzIndex) in hmdpsgzList" :key="hmdpsgzIndex">
            <li style="float:left;margin-top:0px;width:15%;padding:0px;margin-left:1%;margin-right:1%;">
              <div
                style="text-align:center;font-weight:700;font-size:12px;color:#57802b;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana'">
                {{ hmdpsgzItem.createdat.substring(5, 10) }}</div>
              <div style="text-align:center;">{{ hmdpsgzItem.createdat.substring(0, 4) }}</div>
            </li>
            <li style="text-align:left;width:65%;float:left;padding:0px;margin-right:1%;">{{ hmdpsgzItem.articleName }}</li>
            <li @click="showOrHideDetail(hmdpsgzItem.articleId, $event)"
              style="float:left;margin-top:0px;margin-left:1%;margin-right:1%;border:1px solid #8fa926;border-radius:7px;color:#8fa926;width:15px;height:15px;line-height:15px;font-size:15px;">
              +</li>
            <div style="width:100%;height:2px;clear:both;"></div>
            <!-- <li class="detailContent" :id="hmdpsgzItem.articleId" style="width:100%;display:none;text-align:left;" v-html="hmdpsgzItem.content.replaceAll('/uploadfile','http://www.cura.cn/uploadfile')"></li> -->
            <li class="detailContent" :id="hmdpsgzItem.articleId" style="width:100%;display:none;text-align:left;"
              v-html="hmdpsgzItem.content"></li>


          </ul>
        </div>
      </div>





      <!--绿色采购指南 end-->
    </div>





    <div
      :style="{ 'position': 'relative', 'background-image': lscgpl_bmd_cur_bg, 'background-position': '0px 0px', 'width': '100%', 'background-size': '100% 100%', 'overflow': 'hidden', 'height': '710px' }">
      <!--绿色采购品类标准-白名单 start-->

      <img src="static/green_procurement_categories_list_bmd.png"
        style="width:180px;position:absolute;left:40px;top:65px;" />

      <img v-if="$store.state.language === 'cn'" src="static/lscgplbz-bmd.png" style="width:150px;position:absolute;left:40px;top:115px;" />

      <div style="width:50px;position:absolute;right:40px;top:105px;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana',
        margin-top: .625rem;margin-right: .15625rem;font-size: 40px;font-weight: 700;color: #fff; ">
        {{ lscgpl_bmd_cur_number }}</div>
      <div style="width:3px;background:#fff;height:100px;position:absolute;right:65px;top:145px;"></div>

      <div style="position:absolute;top:220px;width:80%;left:10%;margin:0 auto;height:200px;background:#fff;">
        <img :src="lscgpl_bmd_cur_pic" style="width:100%;height:200px;" />
      </div>

      <div style="position:absolute;top:450px;width:80%;left:10%;text-align:left;" v-if="$store.state.language === 'cn'">{{ lscgpl_bmd_cur_ch_title }}</div>
      <div style="position:absolute;top:450px;width:80%;left:10%;text-align:left;" v-else>{{ lscgpl_bmd_cur_en_title }}</div>
      <div style="position:absolute;top:490px;width:80%;left:10%;text-align:left;"  v-if="$store.state.language === 'cn'">{{ lscgpl_bmd_cur_en_title }}</div>

      <div v-if="showbmddetail" class="bmd_detail_content"
        style="position:fixed;z-index:9999999999999;top:10px;left:5%;border:1px solid #;border-radius:10px;background:#fff;height:90%;width:90%;overflow-y:scroll">

        <div @click="hiddenbmddetail()"
          style="cursor:pointer;position:fixed;top:10px;right:20px;font-size:30px;color:#000;border:1px solid #000;border-radius:15px;width:30px;height:30px;line-height:30px;">
          ×</div>

        <div class="bmdDetail" v-html="curBmdDetailHtml"
          style="margin-top:30px;text-align:left;padding-left:3%;padding-right:3%;"></div>

        <!--此div供显示标准内容详情，点击每一条目录的更多后请求对应文章的详情并显示-->
      </div>


      <div class="swiper-container lscgpl_bmd_slide"
        style="width:100%;position:absolute;left:0%;top:590px;height:auto;background:white;overflow:hidden;">
        <!--轮播图-->
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="position:relative;width:100%">
            <div :class="[lscgplqdbmdArr[0].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(0)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">铝合金无铬钝化控制
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Control of chromium free passivation of aluminum alloy
              </div>
            </div>
            <div :class="[lscgplqdbmdArr[1].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(1)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">木材来源合法化
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Legalization of wood sources
              </div>
            </div>
            <div :class="[lscgplqdbmdArr[2].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(2)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">
                室内装饰人造板及其制品甲醛控制 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Interior decorative wood-based panel Formaldehyde control of and its products </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div :class="[lscgplqdbmdArr[3].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(3)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">
                聚苯乙烯类保温材料HBCD阻燃剂有害性控制 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Polystyrene thermal insulation material Harmful control of HBCD flame retardant </div>
            </div>
            <div :class="[lscgplqdbmdArr[4].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(4)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">
                水性涂料烷基酚聚氧乙烯醚（APEO）控制 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Waterborne coating alkyl phenol polyoxyethylene Ethylene ether (APEO) control</div>
            </div>
            <div :class="[lscgplqdbmdArr[5].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(5)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'"> 石材产品清洁生产
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Clean production of stone products
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div :class="[lscgplqdbmdArr[6].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(6)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'"> 门窗节能控制
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Energy Saving Control of Doors and Windows
              </div>
            </div>
            <div :class="[lscgplqdbmdArr[7].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(7)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">
                LED光源健康与环保控制 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  LED Light Source Health and Environmental Protection Control </div>
            </div>
            <div :class="[lscgplqdbmdArr[8].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(8)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'"> 无铬钝化轻钢龙骨
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Chrome-free Passivated Light Steel Keel
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div :class="[lscgplqdbmdArr[9].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(9)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">
                空气源热泵品质与环保控制 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Quality and Environmental Protection Control of Air Source Heat Pump </div>
            </div>
            <div :class="[lscgplqdbmdArr[10].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(10)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'"> 岩棉品质与环保控制
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Quality and Environmental Protection Control of Rock Wool Quality
              </div>
            </div>
            <div :class="[lscgplqdbmdArr[11].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgplbmdItem(11)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">
                石木塑（SPC石晶）墙地材 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Stone Wood Plastic Wall and Floor Materials </div>
            </div>
          </div>
        </div>


        <!-- 如果需要分页器
                                            <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
                                                  <div class="swiper-button-next"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>

      <!-- <img src="static/know_more.png" @click="getlscgplbmddetail()"
        style="position:absolute;bottom:140px;left:36%;width:100px;" /> -->
        <div  v-if="$store.state.language === 'cn'" @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; position:absolute;bottom:140px;height: 25px;line-height:25px;left:36%;width:100px;color: white;font-size: 13px;" >了解更多</div>
        <div v-else @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; position:absolute;bottom:140px;height: 25px;line-height:25px;left:36%;width:100px;color: white;font-size: 13px;" >More</div>

      <!--绿色采购品类标准-白名单 end-->
    </div>





    <div
      :style="{ 'position': 'relative', 'background-image': lscgpl_lmd_cur_bg, 'background-position': '0px 0px', 'width': '100%', 'background-size': '100% 100%', 'overflow': 'hidden', 'height': '710px' }">
      <!--绿色采购品类标准-绿名单 start-->

      <img src="static/green_procurement_categories_list_lmd.png"
        style="width:180px;position:absolute;left:40px;top:65px;" />

      <img v-if="$store.state.language === 'cn'" src="static/lscgplbz-lmd.png" style="width:150px;position:absolute;left:40px;top:115px;" />

      <div style="width:50px;position:absolute;right:40px;top:105px;font-family:'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana',
        margin-top: .625rem;margin-right: .15625rem;font-size: 40px;font-weight: 700;color: #fff; ">
        {{ lscgpl_lmd_cur_number }}</div>
      <div style="width:3px;background:#fff;height:100px;position:absolute;right:65px;top:145px;"></div>

      <div style="position:absolute;top:220px;width:80%;left:10%;margin:0 auto;height:200px;background:#fff;">
        <img :src="lscgpl_lmd_cur_pic" style="width:100%;height:200px;" />
      </div>

      <div style="position:absolute;top:450px;width:80%;left:10%;text-align:left;">{{ lscgpl_lmd_cur_ch_title }}</div>

      <div style="position:absolute;top:490px;width:80%;left:10%;text-align:left;">{{ lscgpl_lmd_cur_en_title }}</div>


      <div v-if="showlmddetail" class="lmd_detail_content"
        style="position:fixed;z-index:9999999999999;top:10px;left:5%;border:1px solid #;border-radius:10px;background:#fff;height:90%;width:90%;overflow-y:scroll">

        <div @click="hiddenlmddetail()"
          style="cursor:pointer;position:fixed;top:20px;right:20px;font-size:30px;color:#000;border:1px solid #000;border-radius:15px;width:30px;height:30px;line-height:30px;">
          ×</div>

        <div class="lmdDetail" v-html="curLmdDetailHtml"
          style="margin-top:20px;text-align:left;padding-left:3%;padding-right:3%;"></div>

        <!--此div供显示标准内容详情，点击每一条目录的更多后请求对应文章的详情并显示-->
      </div>





      <div class="swiper-container lscgpl_lmd_slide"
        style="width:100%;position:absolute;left:0%;top:590px;height:50px;background:white;overflow:hidden;">
        <!--轮播图-->
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div :class="[lscgplqdlmdArr[0].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(0)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'"> 钢铁企业绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Green List Criteria of Iron and Steel Enterprises
              </div>
            </div>
            <div :class="[lscgplqdlmdArr[1].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(1)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">
                水泥类企业绿名单评价导则 </div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Green List Criteria of Cement Enterprises </div>
            </div>
            <div :class="[lscgplqdlmdArr[2].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(2)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'">铝合金企业绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Green List Criteria of Aluminum Alloy Enterprises
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div :class="[lscgplqdlmdArr[3].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(3)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">玻璃企业绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Green List Criteria of Glass Enterprises
              </div>
            </div>
            <div :class="[lscgplqdlmdArr[4].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(4)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">
                烧结墙体材料企业绿名单评价导则</div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Green List Criteria of Sintered Wall Material Enterprises</div>
            </div>
            <div :class="[lscgplqdlmdArr[5].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(5)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;"  v-if="$store.state.language === 'cn'"> 涂料企业绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else> Green List Criteria of Coating Material Enterprises
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div :class="[lscgplqdlmdArr[6].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(6)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">
                空气源热泵采购绿名单评价导则</div>
                <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>
                  Green List Criteria of Air Source Heat Pump Enterprises</div>
            </div>
            <div :class="[lscgplqdlmdArr[7].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(7)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">岩棉采购绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Green List Criteria of Rock Wool Enterprises
              </div>
            </div>

            <div :class="[lscgplqdlmdArr[8].show ? 'lscgplqd_item active' : 'lscgplqd_item noActive']"
              @click="showLscgpllmdItem(8)">
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-if="$store.state.language === 'cn'">石材企业绿名单评价导则
              </div>
              <div style="width:100%;display: flex;align-items: center;height: 50px;justify-content: center;" v-else>Green List Criteria of Stone Wood Plastic Wall and Floor Materials Enterprises
              </div>
            </div>

          </div>

        </div>
        <!-- 如果需要分页器
                                            <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
                                                  <div class="swiper-button-next"></div> -->

        <!-- 如果需要滚动条 -->
        <!-- <div class="swiper-scrollbar"></div> -->
      </div>

      <!-- <img src="static/know_more.png" @click="getlscgpllmddetail()"
        style="position:absolute;bottom:140px;left:36%;width:100px;" /> -->


        <div  v-if="$store.state.language === 'cn'" @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; position:absolute;bottom:140px;height: 25px;line-height:25px;left:36%;width:100px;color: white;font-size: 13px;" >了解更多</div>
        <div v-else @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; position:absolute;bottom:140px;height: 25px;line-height:25px;left:36%;width:100px;color: white;font-size: 13px;" >More</div>
      <!--绿色采购品类标准-绿名单 end-->
    </div>










    <div
      :style="{ 'position': 'relative', 'background': 'url(static/green_supply_chain_list_big_bg.png) no-repeat', 'background-size': '100% 100%', 'background-position': '0px 0px', 'width': '100%', 'overflow': 'hidden', 'height': '780px' }">
      <!--绿色供应链名单 start-->

      <img src="static/green_supply_chain_list_en_title.png" style="width:200px;position:absolute;left:40px;top:65px;" />

      <img v-if="$store.state.language === 'cn'" src="static/green_supply_chain_list_ch_title.png" style="width:140px;position:absolute;left:40px;top:125px;" />


      <div class="swiper-container green_supply_chain_slide"
        style="position:absolute;top:150px;height:550px;overflow:hidden;">
        <!--轮播图-->
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="position:relative;">
            <router-link to="supplierNameList?mdType=0">
              <img src="static/supply_white_item_bg.jpg" />
              <div class="supplier_item_under_text" style=""><span  v-if="$store.state.language === 'cn'">供应商白名单</span><br>White List</div>
            </router-link>
          </div>
          <div class="swiper-slide" style="position:relative;">
            <router-link to="supplierNameList?mdType=1">
              <img src="static/supply_green_item_bg.jpg" />
              <div class="supplier_item_under_text" style=""><span  v-if="$store.state.language === 'cn'">供应商绿名单</span><br>Green List</div>
            </router-link>
          </div>
          <!-- <div class="swiper-slide" style="position:relative;">
            <router-link to="supplierNameList?mdType=2">
              <img src="static/supply_black_item_bg.jpg" />
              <div class="supplier_item_under_text" style=""><span  v-if="$store.state.language === 'cn'">供应商黑名单</span><br>Black List</div>
            </router-link>
          </div> -->
          <div class="swiper-slide" style="position:relative;">
            <router-link to="supplierNameList?mdType=3">
              <img src="static/supply_jcjg_gongshi.jpg" />
              <div class="supplier_item_under_text" style="font-size:17px"><span  v-if="$store.state.language === 'cn'">环境合规白名单</span><br>Environmental Compliance White List</div>
            </router-link>
          </div>


        </div>



        <div class="swiper-button-next green_supply_chain_next"
          style="background-color:#fff;border-radius:15px;width:30px;height:30px;background:url(static/supply_slide_go_right.png);background-size:100% 100%;position:absolute;right:auto;right:10px;bottom:20px;">

        </div>
        <div class="swiper-button-prev green_supply_chain_prev"
          style="background-color:#fff;border-radius:15px;width:30px;height:30px;background:url(static/supply_slide_go_left.png);background-size:100% 100%;position:absolute;left:auto;left:10px;bottom:20px;">
        </div>


      </div>


      <!--绿色供应链接名单 end-->
    </div>


    <router-link to="joinUs">
      <div
        :style="{ 'position': 'relative', 'background': 'url(static/immediately_bg.png) no-repeat', 'background-size': '90% 100%', 'background-position': '0px 0px', 'width': '100%', 'overflow': 'hidden' }">
        <!--马上行动 start-->

        <div style="position:relative;height:400px;">

          <img src="static/join_the_green_chain_act_now.png" style="width:250px;position:absolute;right:20px;top:50px;" />

          <img v-if="$store.state.language === 'cn'" src="static/msxd.png" style="width:180px;position:absolute;right:20px;top:150px;" />

          <!-- <img src="static/apply.png" style="width:150px;position:absolute;right:20px;top:280px;" /> -->


          <div  v-if="$store.state.language === 'cn'" @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; width:150px;position:absolute;right:20px;top:280px;height: 25px;line-height:25px;color: white;font-size: 13px;" >点击申请</div>
        <div v-else @click="getlscgplbmddetail()"
        style="background: url(&quot;static/more_news_bg2.png&quot;) 100% center no-repeat; width:150px;position:absolute;right:20px;top:280px;height: 25px;line-height:25px;color: white;font-size: 13px;" >Apply</div>


          <!--马上行动 end-->
        </div>

      </div>
    </router-link>



    <!--底部组件-->
    <friendLinkAndFooter></friendLinkAndFooter>






  </div>
</template>


<script>
import { articleListByPage,articleDetail } from "@/api";
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import topNav from '@/components/topNav'
import friendLinkAndFooter from '@/components/friendLinkAndFooter'
import { frontChannelOneLevelArticleType, getFrontChannelArticleTypeSubApi } from '@/api'
import { mapActions } from 'vuex';
export default {
  name: 'index',
  components:{
   topNav,friendLinkAndFooter
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      
      showNav:false,
      slide01show01: true,
      slide01show02: false,
      slide01show03: false,
      lscgzn:true,
      bmdpsgz:false,
      lmdpsgz:false,
      hmdpsgz:false,
      lscgznNew:{},
      bmdpsgzList:[],
      lmdpsgzList:[],
      hmdpsgzList:[],
      pages: 1,
      //最新动态新闻
      latestNewslist:[],
      lscgpl_bmd_cur_pic:'static/lscgpl_01.jpg',
      lscgpl_bmd_cur_bg:'url(static/lscgplqd_bg_01.png)',
      lscgpl_bmd_cur_number:'01',
      lscgpl_bmd_cur_ch_title:'铝合金无铬钝化控制',
      lscgpl_bmd_cur_en_title:'Control of chromium free passivation of aluminum alloy',
      curBmdDetailHtml:'',
      curLmdDetailHtml:'',
      showbmddetail:false,
      showlmddetail:false,
      lscgpl_lmd_cur_ch_title:'钢铁企业绿名单评价导则',
      lscgpl_lmd_cur_en_title:'Green List Criteria of Iron and Steel Enterprises',
      lscgpl_lmd_cur_pic:'static/lscgpl_13.jpg',
      lscgpl_lmd_cur_bg:'url(static/lscgplqd_lmd_bg_01.png)',
      lscgpl_lmd_cur_number:'01',
      lscgplqdbmdArr:[
        {show:true,img:'static/lscgpl_01.jpg',articleCode:'WZNR202106041416290032',chTitle:'铝合金无铬钝化控制',enTitle:'Control of chromium free passivation of aluminum alloy'},
        {show:false,img:'static/lscgpl_02.jpg',articleCode:'000000061',chTitle:'木材来源合法化',enTitle:'Legalization of wood sources'},
        {show:false,img:'static/lscgpl_03.jpg',articleCode:'WZNR202106041514120035',chTitle:'室内装饰人造板及其制品甲醛控制',enTitle:'Interior decorative wood-based panel Formaldehyde control of and its products'},
        {show:false,img:'static/lscgpl_04.jpg',articleCode:'WZNR201908190447200078',chTitle:'聚苯乙烯类保温材料HBCD阻燃剂有害性控制',enTitle:'Polystyrene thermal insulation material Harmful control of HBCD flame retardant'},
        {show:false,img:'static/lscgpl_05.jpg',articleCode:'WZNR201908190434580077',chTitle:'水性涂料烷基酚聚氧乙烯醚（APEO）控制',enTitle:'Waterborne coating alkyl phenol polyoxyethylene Ethylene ether (APEO) control'},
        {show:false,img:'static/lscgpl_06.jpg',articleCode:'WZNR201807091655440022',chTitle:'石材产品清洁生产',enTitle:'Clean production of stone products'},
        {show:false,img:'static/lscgpl_07.jpg',articleCode:'WZNR202010281244130025',chTitle:'门窗节能控制',enTitle:'Energy Saving Control of Doors and Windows'},
        {show:false,img:'static/lscgpl_08.jpg',articleCode:'WZNR202010281233050024',chTitle:'LED光源健康与环保控制',enTitle:'LED Light Source Health and Environmental Protection Control'},
        {show:false,img:'static/lscgpl_09.jpg',articleCode:'WZNR202010281203310023',chTitle:'无铬钝化轻钢龙骨',enTitle:'Chrome-free Passivated Light Steel Keel'},
        {show:false,img:'static/lscgpl_10.jpg',articleCode:'WZNR202106041442350034',chTitle:'空气源热泵品质与环保控制',enTitle:'Quality and Environmental Protection Control of Air Source Heat Pump'},
        {show:false,img:'static/lscgpl_11.jpg',articleCode:'WZNR202106041436230033',chTitle:'岩棉品质与环保控制',enTitle:'Quality and Environmental Protection Control of Rock Wool Quality'},
        {show:false,img:'static/lscgpl_12.jpg',articleCode:'WZNR202106041524210036',chTitle:'石木塑（SPC石晶）墙地材',enTitle:'Stone Wood Plastic Wall and Floor Materials'}
      ],
      lscgplqdlmdArr:[
        {show:true,img:'static/lscgpl_13.jpg',articleCode:'WZNR202009171021560003',chTitle:'钢铁企业绿名单评价导则',enTitle:'Green List Criteria of Iron and Steel Enterprises'},
        {show:false,img:'static/lscgpl_14.jpg',articleCode:'WZNR202009171056190004',chTitle:'水泥类企业绿名单评价导则',enTitle:'Green List Criteria of Cement Enterprises'},
        {show:false,img:'static/lscgpl_15.jpg',articleCode:'WZNR202009171102150005',chTitle:'铝合金企业绿名单评价导则',enTitle:'Green List Criteria of Aluminum Alloy Enterprises'},
        {show:false,img:'static/lscgpl_16.jpg',articleCode:'WZNR202009171113410006',chTitle:'玻璃企业绿名单评价导则',enTitle:'Green List Criteria of Glass Enterprises'},
        {show:false,img:'static/lscgpl_17.jpg',articleCode:'WZNR202009171117540007',chTitle:'烧结墙体材料企业绿名单评价导则',enTitle:'Green List Criteria of Sintered Wall Material Enterprises'},
        {show:false,img:'static/lscgpl_18.jpg',articleCode:'WZNR202009171121320008',chTitle:'涂料企业绿名单评价导则',enTitle:'Green List Criteria of Coating Material Enterprises'},
        {show:false,img:'static/lscgpl_10.jpg',articleCode:'WZNR202112201930430001',chTitle:'空气源热泵采购绿名单评价导则',enTitle:'Green List Criteria of Air Source Heat Pump Enterprises'},
        {show:false,img:'static/lscgpl_11.jpg',articleCode:'WZNR202112201942560002',chTitle:'岩棉采购绿名单评价导则',enTitle:'Green List Criteria of Rock Wool Enterprises'},
        {show:false,img:'static/lscgpl_06.jpg',articleCode:'WZNR202112211708230004',chTitle:'石材企业绿名单评价导则',enTitle:'Green List Criteria of Stone Wood Plastic Wall and Floor Materials Enterprises'}
      ]
    }
  },
  methods :{
    ...mapActions(['changeLanguage', 'loadTypeLists', 'changeType', 'changeSubType']),
      hiddenbmddetail(){
        this.showbmddetail=false
      },
      hiddenlmddetail(){
        this.showlmddetail=false
      },
      showLscgplbmdItem(i){
         var that=this;
         that.lscgplqdbmdArr[i].show=true;
         that.lscgpl_bmd_cur_pic=that.lscgplqdbmdArr[i].img;
         that.lscgpl_bmd_cur_ch_title=that.lscgplqdbmdArr[i].chTitle;
         that.lscgpl_bmd_cur_en_title=that.lscgplqdbmdArr[i].enTitle;
         
          that.lscgpl_bmd_cur_number=(i+1).toString().length<2?'0'+(i+1):i+1;
          that.lscgpl_bmd_cur_bg='url(static/lscgplqd_bg_'+that.lscgpl_bmd_cur_number+'.png)'
         for(var t=0;t<that.lscgplqdbmdArr.length;t++){
           if(t!=i){
             that.lscgplqdbmdArr[t].show=false;
           }
         }

      },

   getlscgplbmddetail(){

       var curIitemIndex=parseInt(this.lscgpl_bmd_cur_number);
         
        var articleCode=this.lscgplqdbmdArr[curIitemIndex-1].articleCode;

        var params = { articleId: articleCode, isEn: this.$store.state.language === 'en' ? 1 : 0 }
         
         articleDetail(params).then((res) => {
                // console.log(res);
                this.curBmdDetailHtml = res.data.content;
                // this.list = [res.data]
                // this.content = 
                  this.showbmddetail=true

          
              setTimeout(() => {

            var o=document.querySelectorAll('.bmdDetail img');
        
              if(o){
                for(var i=0;i<o.length;i++){
                  o[i].setAttribute("style","width:100%")
                }
              }
                
              }, 300);

              })




      

      },


      showLscgpllmdItem(i){
         var that=this;
         that.lscgplqdlmdArr[i].show=true;
         that.lscgpl_lmd_cur_pic=that.lscgplqdlmdArr[i].img;
         that.lscgpl_lmd_cur_ch_title=that.lscgplqdlmdArr[i].chTitle;
         that.lscgpl_lmd_cur_en_title=that.lscgplqdlmdArr[i].enTitle;
         
          that.lscgpl_lmd_cur_number=(i+1).toString().length<2?'0'+(i+1):i+1;
          that.lscgpl_lmd_cur_bg='url(static/lscgplqd_lmd_bg_'+that.lscgpl_lmd_cur_number+'.png)'
         for(var t=0;t<that.lscgplqdlmdArr.length;t++){
           if(t!=i){
             that.lscgplqdlmdArr[t].show=false;
           }
         }

      },

      getlscgpllmddetail(){
       var curIitemIndex=parseInt(this.lscgpl_lmd_cur_number);
         
        var articleCode=this.lscgplqdlmdArr[curIitemIndex-1].articleCode;

        var params = { articleId: articleCode, isEn: this.$store.state.language === 'en' ? 1 : 0 }
         
         articleDetail(params).then((res) => {
                // console.log(res);
                this.curLmdDetailHtml = res.data.content;
                // this.list = [res.data]
                // this.content = 
                  this.showlmddetail=true

          
              setTimeout(() => {

            var o=document.querySelectorAll('.lmdDetail img');
        
              if(o){
                for(var i=0;i<o.length;i++){
                  o[i].setAttribute("style","width:100%")
                }
              }
                
              }, 300);
              
              })

      },

      getlscgzn(){
      //绿色采购指南
      var that=this;
      that.lscgzn=true;
      that.bmdpsgz=false;
      that.lmdpsgz=false;
      that.hmdpsgz=false;

      },
      async getFrontChannel() {
        
    },
    showOrHideDetail(articleCode,event){
      if(event.target.innerHTML=='+'){
        document.getElementById(articleCode).setAttribute("style","display:block")
        event.target.innerHTML='-';
      }else{
        document.getElementById(articleCode).setAttribute("style","display:none")
        event.target.innerHTML='+';
      }

    },


       getbmdpsgz(){
      //白名单评审规则
      var that=this;
      that.lscgzn=false;
      that.bmdpsgz=true;
      that.lmdpsgz=false;
      that.hmdpsgz=false;

       const params = {
              page: that.pages,
              catCode: "000003%7C000036",
              limit:9999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              console.log(res.data);
              that.bmdpsgzList = res.data.list;


              setTimeout(() => {

            var o=document.querySelectorAll('.detailContent img');
        
              if(o){
                for(var i=0;i<o.length;i++){
                  o[i].setAttribute("style","width:100%")
                }
              }
                
              }, 1000);


            });

      },
       getlmdpsgz(){
      //绿名单评审规则
      var that=this;
      that.lscgzn=false;
      that.bmdpsgz=false;
      that.lmdpsgz=true;
      that.hmdpsgz=false;
        const params = {
              page: that.pages,
              catCode: "000003%7C000040",
              limit:9999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              console.log(res.data);
              that.lmdpsgzList = res.data.list;

                    setTimeout(() => {

     var o=document.querySelectorAll('.detailContent img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);
            });

      },
       gethmdpsgz(){
      //黑名单评审规则
      var that=this;
      that.lscgzn=false;
      that.bmdpsgz=false;
      that.lmdpsgz=false;
      that.hmdpsgz=true;
            const params = {
              page: that.pages,
              catCode: "000003%7C000041",
              limit:9999,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              console.log(res.data);
              that.hmdpsgzList = res.data.list;

                    setTimeout(() => {

     var o=document.querySelectorAll('.detailContent img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);
            });

      },

    articleDetail(){
      const params = {
          articleId: "WZNR201610311925050025",
          isEn: this.$store.state.language === 'en' ? 1 : 0
        }
        articleDetail(params).then((res) => {
          // console.log(res);
          this.lscgznNew = res.data || {}
          // this.list = [res.data]
          // this.content = 
        })

    },

   articleListByPage() {
        var that=this
            // console.log(this.dateY,' =====____');
            const params = {
              page: that.pages,
              catCode: "000002%7C000012",
              limit:3,
              isEn: this.$store.state.language === 'en' ? 1 : 0
            };
            articleListByPage(params).then(res => {
              console.log(res.data);
              that.latestNewslist = res.data.list;
            });
          }
  },
   mounted() {
     var that=this;

      //加载新闻
      this.articleListByPage();
      this.articleDetail();
      this.getFrontChannel()

      var mySwiper = new Swiper('.swiper_fqz', {
        loop: true,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        //如果需要自动切换海报
         autoplay: {
           delay: 3000//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
        },
        on: {
          slideChange: function(){
            //console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            if(this.activeIndex==2){
             that.slide01show01 = true;
             that.slide01show02 = false;
             that.slide01show03 = false;
             

            }else if(this.activeIndex==3){

             that.slide01show01 = false;
             that.slide01show02 = true;
             that.slide01show03 = false;
             
            }else if(this.activeIndex==4){

             that.slide01show01 = false;
             that.slide01show02 = false;
             that.slide01show03 = true;
               

            }
          },
        },
      })




      var mySwiperNews = new Swiper('.swiper_news', {
        loop: true,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        //如果需要自动切换海报
         autoplay: {
           delay: 3000//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
        },
        on: {
          slideChange: function(){
            //console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            if(this.activeIndex==2){
         

            }else if(this.activeIndex==3){

            
            }else if(this.activeIndex==4){

              

            }
          },
        },
      })




        var mySwiperlscgplbmd = new Swiper('.lscgpl_bmd_slide', {
        loop: false,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        //如果需要自动切换海报
         //autoplay: {
          // delay: 3000//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
        //},
        on: {
          slideChange: function(){
            //console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            if(this.activeIndex==2){
         

            }else if(this.activeIndex==3){

            
            }else if(this.activeIndex==4){

              

            }
          },
        },
      })



      
        var mySwiperlscgpllmd = new Swiper('.lscgpl_lmd_slide', {
        loop: false,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        // 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        //如果需要自动切换海报
         //autoplay: {
          // delay: 3000//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
        //},
        on: {
          slideChange: function(){
            //console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            if(this.activeIndex==2){
         

            }else if(this.activeIndex==3){

            
            }else if(this.activeIndex==4){

              

            }
          },
        },
      })




      
        var mySwiperGreenSupply = new Swiper('.green_supply_chain_slide', {
        loop: false,
        // 如果需要分页器
        pagination: '.swiper-pagination .green_supply_chain',
        // 如果需要前进后退按钮
        nextButton: '.green_supply_chain_next',
        prevButton: '.green_supply_chain_prev',
        // 如果需要滚动条
        scrollbar: '.swiper-scrollbar',
        //如果需要自动切换海报
        autoplay: {
          delay: 3000//时间 毫秒
        //   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
         },
         navigation:{

            nextEl:'.green_supply_chain_next',
            prevEl:'.green_supply_chain_prev'
         },
        on: {
          slideChange: function(){
            //console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            if(this.activeIndex==2){
         

            }else if(this.activeIndex==3){

            
            }else if(this.activeIndex==4){

              

            }
          },
        },
      })




      setTimeout(() => {

     var o=document.querySelectorAll('.detailContent img');
 
      if(o){
        for(var i=0;i<o.length;i++){
          o[i].setAttribute("style","width:100%")
        }
      }
        
      }, 1000);




    },
  methods: {
    addck(val) {
      switch (val) {
        case 1:
          window.location.href = 'https://gsc.see.org.cn/#/content/AboutGSC/RealEstateEnterprisesDirectory';
          break;
        case 2:
          window.location.href = 'https://gsc.see.org.cn/#/content/AssessmentStandards/GreenListAssessmentStandards';
          break;
        case 3:
          window.location.href = 'https://gsc.see.org.cn/#/content/AssessmentStandards/WhiteListAssessmentStandards';
          break;
        case 4:
          window.location.href = 'https://gsc.see.org.cn/#/content/SuppliersList/Greenlist';
          break;
        case 5:
          window.location.href = 'https://gsc.see.org.cn/#/content/SuppliersList/EnvironmentalComplianceWhiteListDatabase';
          break;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>.brief_1 {
  font-size: 20px;
  font-weight: 900;
  color: #fff;
}

.Impact {
  font-family: Impact, 微软雅黑;
}

.swiper-container {
  width: 100%;
  height: 300px;
  margin: 20px auto;
}

.show {
  display: block;
}

.item {
  width: 100%;
  height: 50px;
  margin: 0px;
  display: block;
}

.itemActive {
  background: url('../../static/item_current_bg.png') repeat-x;
}

.itemNoActive {
  background: url('../../static/item_nocur_bg.png') repeat-x;
}

.hidden {
  display: none;
}

.index {
  margin: 0px;
  padding: 0px;
  width: 100%;
  min-height: 960px;
}

.lscgzn_content_box,
.bmdpsgz_content_box,
.lmdpsgz_content_box,
.hmdpsgz_content_box {
  min-height: 500px;
  width: 65%;
  position: absolute;
  left: 30%;
  top: 160px;
  position: absolute;
  right: 0px;
  background-color: #ffffff;
  font-size: 12px;
}
.pos_rit_bg {
  position: absolute;
  bottom: 9%;
  width: 100%;
  height: 120px;
  border-radius: 14px;
  background: #ffffffab;
}

.flex_1 {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin-left: 5%;
  flex-wrap: wrap;
  /* padding-top: 98px; */
  /* position: absolute; */
  /* bottom: 12%; */
  z-index: 2;
}

.pos_rit {
  position: relative;
  width: 47%;
  margin: 10px 0;
}

.font_style_fx {
  color: #92ab26;
  font-size: 30px;
  font-weight: 900;
}

.font_pos {
  font-size: 18px;
  color: #92ab26;
  position: absolute;
  top: 20px;
  right: 6px;
}

.supplier_item_under_text {
  font-weight: 700;
  font-size: 20px;
  color: #ffffff;
  font-family: 'SourceHanSansCN,Microsoft Yahei,微软雅黑,verdana';
  position: absolute;
  bottom: 100px;
  width: 100%;
}

.lscgplqd_item {
  text-align: center;
  width: 31%;
  padding-left: 1%;
  padding-right: 1%;
  float: left;
  height: 50px;
  font-size: 12px;
  border-right: 1px solid rgb(146, 171, 38)
}

.noActive {
  background-color: #ffffff;
  color: #000000
}

.active {
  background-color: rgb(146, 171, 38);
  color: #ffffff;
}

.lscgzn_content_html::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #ffffff;
}

/*定义滚动条轨道 内阴影+圆角*/
.lscgzn_content_html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: #ffffff;
}

/*定义滑块 内阴影+圆角*/
.lscgzn_content_html::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #7b9f20;
}


.bmdpsgz_list_box {
  padding-left: 1%;
  padding-right: 1%;
  max-height: 500px;
  overflow-y: scroll;
  width: 95%;
  position: absolute;
  top: 15%;
  height: 85%
}

.mdpsgz_item {
  margin: 0px;
  padding: 10px 0px;
  border-bottom: 1px solid #8fa926;
  overflow: hidden;
}

.bmdpsgz_list_box::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #ffffff;
}

/*定义滚动条轨道 内阴影+圆角*/
.bmdpsgz_list_box::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: #ffffff;
}

/*定义滑块 内阴影+圆角*/
.bmdpsgz_list_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #7b9f20;
}



h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}</style>



// WEBPACK FOOTER //
// src/components/index.vue